import { render, staticRenderFns } from "./headerTab.vue?vue&type=template&id=3dc5c83c&"
import script from "./headerTab.vue?vue&type=script&lang=js&"
export * from "./headerTab.vue?vue&type=script&lang=js&"
import style0 from "./headerTab.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports